import React from 'react';

interface StatusBadgeProps {
  /** Canonical event `latest_status` string (open set; e.g. `Analyzed`,
   * `Modified`, `Withdrawn`, `Exploited`, `Awaiting Analysis`). */
  status: string | null | undefined;
}

export function StatusBadge({ status }: StatusBadgeProps): React.JSX.Element {
  const label = status || 'Unknown';
  return (
    <span
      className="status-badge"
      data-status={label}
      aria-label={`Status: ${label}`}
    >
      {label}
    </span>
  );
}
